import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { VideoUrlInput } from '~/components/VideoUrlInput/VideoUrlInput';
export const GetVideoPageContentTID = (parentTestId)=>getTestIds(parentTestId);
export const VideoPageContent = (param)=>{
    let { value, onChange, disabled, submitAttempted, testId } = param;
    const testIds = useMemo(()=>GetVideoPageContentTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        testId: testIds.VideoPageContentTestIds.Root(),
        children: /*#__PURE__*/ _jsx(VideoUrlInput, {
            value: value,
            onChange: onChange,
            disabled: disabled,
            required: !disabled,
            showPreviewButton: true,
            submitAttempted: disabled ? undefined : submitAttempted,
            testId: testIds.VideoPageContentTestIds.VideoUrlInput()
        })
    });
};
